module.exports = require('./lib/speakingurl');



//////////////////
// WEBPACK FOOTER
// ./node_modules/speakingurl/index.js
// module id = 25
// module chunks = 0